import "./createProfileStyles.css";
import { toast} from 'react-toastify';
import { useState} from "react";
import { useAddress } from "@thirdweb-dev/react";
import { lensClient } from "../../client/LensClient";
import { isRelaySuccess } from "@lens-protocol/client";


export default function CreateProfile() {

    const [formInput, setFormInput] = useState({
        handle:"",
      });

    const address = useAddress();

      // this was lens v1 method, no longer useful
      // const [createProfile, { data, loading, error }] = useMutation(
      //   CREATE_PROFILE,
      //   {
      //     onCompleted: () => {

      //       if(flag===1){
      //           toast.info("Handle Already Taken",{
      //             position:toast.POSITION.TOP_CENTER
      //           }) 
      //       }
      //       else if(flag===0){
      //         toast.info("Profile Created Successfully!",{
      //           position:toast.POSITION.TOP_CENTER
      //         })
      //       }            
      //     },
      //     onError: (error) =>{
      //       toast.info(<div>Submission error "{error.message}".</div>,{
      //       position:toast.POSITION.TOP_CENTER
      //       }) 
      //     }
      //   }
      // );

      //v2 method using lens client sdk
      const handleCreateProfile = async () => {
        if (formInput.handle==="") {
          toast.info("Enter Your Handle!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else{
          const profileCreateResult = await lensClient.wallet.createProfile({
            handle: formInput.handle,
            to: address,
          })
          if(profileCreateResult?.reason==="HANDLE_TAKEN"){
            toast.info("Handle Already Taken!!",{
              position:toast.POSITION.TOP_CENTER
            })
          }
          else{
            // profileCreateResult is a Result object
            const profileCreateResultValue = profileCreateResult.unwrap()
          
            if (!isRelaySuccess(profileCreateResultValue)) {
              toast.info("Something went wrong",{
                position:toast.POSITION.TOP_CENTER
              })
              console.log(`Something went wrong`, profileCreateResultValue)
              return
            }

            await lensClient.transaction.waitUntilComplete({
              forTxId: profileCreateResultValue.txId,
           })
          toast.success("Profile Created Successfully",{
            position:toast.POSITION.TOP_CENTER
          })
        };
        }
      }

    return(
      <>
        <div className="box">
             <div className="publishform">
                <div className="name-div">
                    <p>Handle</p>
                <input name="handle" onChange={
                    (prop) => setFormInput({
                        ...formInput,
                        handle: prop.target.value
                    })
                    } placeholder="Handle" required/>
                </div>

                {/* <div className="Upload">
                    <div className="cover-div">
                        <p>Profile Image</p>
                    <div className="dotted-div">
                    <div className="top">
                        <input className="uploadCover" type="file" id="profileImage" onChange={pImg}/>
                    </div>
                    </div>
              </div>
            </div> */}
            <div className="btn">
              <button className="submit"  onClick={handleCreateProfile}>Submit</button>
            </div>
        </div>
        </div>

        </>
    );
}
